import { render, staticRenderFns } from "./JTime.vue?vue&type=template&id=355e0574&scoped=true&"
import script from "./JTime.vue?vue&type=script&lang=js&"
export * from "./JTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355e0574",
  null
  
)

export default component.exports